// extracted by mini-css-extract-plugin
export var container = "_6y-0";
export var infoButton = "_6y-1";
export var label = "_6y-3";
export var labelExpanded = "_6y-4";
export var price = "_6y-5";
export var priceExpanded = "_6y-6";
export var title = "_6y-2";